import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceActionPartyDto extends EpimsBaseEntityDto {
	 CorrespondenceActionPartyName: string;
   CorrespondenceTeamId: string;
   StaffId: string;
   Email: string;
   SubscriptionUserId: string;
  Version: number;
}
